import { useDispatch, useSelector } from 'react-redux'
import React, { useCallback } from 'react'
import { close, setStep, STEPS } from 'components/QuestionnaireRequestAutomated/processor/slices/interstitialSlice'
import {
  getFormInstance,
  selectAnySignedSigntures,
} from 'components/QuestionnaireRequestAutomated/processor/slices/formInstanceSlice'
import SignEditSwitchButtons from 'components/QuestionnaireRequestAutomated/processor/components/ProcessInterstitial/SignEditSwitchButtons'
import { clsx } from 'clsx'

const Header = () => {
  const formInstanceId = useSelector((state) => state.global.formInstanceId)
  const isAnySignedSignatures = useSelector(selectAnySignedSigntures)
  const dispatch = useDispatch()
  const onClose = useCallback(() => {
    dispatch(close())
    dispatch(getFormInstance(formInstanceId))
  }, [dispatch])
  const onBackToFields = useCallback(() => {
    dispatch(getFormInstance(formInstanceId))
    dispatch(setStep(STEPS.fields))
  }, [dispatch])

  return (
    <div className="questionnaire-request-interstitial-sign-header">
      <div className="dome-d-flex dome-justify-between" style={{ padding: '6px 0px 12px 0px' }}>
        <div className="dome-d-flex dome-gap18">
          <span className="dome-h3 dome-color-darkest-grey">sign form</span>
          <button
            type="button"
            onClick={onBackToFields}
            disabled={isAnySignedSignatures}
            className={clsx('dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left', {
              'dome-cursor-not-allowed': isAnySignedSignatures,
            })}
          >
            back to fields
          </button>
        </div>
        <div className="dome-d-flex dome-align-center dome-gap18">
          <SignEditSwitchButtons />
          <button type="button" className="dome-btn dome-btn-base dome-btn-dark-green" onClick={onClose}>
            save + close
          </button>
          <span onClick={onClose} className="dome-cursor-pointer">
            <i className="fa-solid fa-xmark-large dome-color-med-grey"></i>
          </span>
        </div>
      </div>
    </div>
  )
}

export default Header
